import { Component } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';

import { MSISDNUPDATEVIEWLABELS, SHAREDCONSTANTS } from '../../_constants/constants';
import { CustomerService } from '../../_services/customer.service';
import { SmsURLService } from '../../_services/smsurl.service';

import { NotificationDialogComponent } from './../../notification/notification.dialog.component';

import { TranslatePipe } from '../../shared/translate/translate.pipe';

export interface MsisdnupdateModel {
    title: string;
    // current_msisdn_label: string;
    // new_msisdn_label: string;
    description: string;
    oldMsisdn: string;
    subValue: string;
    opcoValue: string;
    customerService: CustomerService;
    smsurlService: SmsURLService;
}

@Component({
    templateUrl: 'msisdn.update.dialog.component.html',
    providers: [TranslatePipe]
})

export class MSISDNupdateComponent extends DialogComponent<MsisdnupdateModel, string> implements MsisdnupdateModel {
    subValue: string;
    opcoValue: string;
    title: string;
    // new_msisdn_label = 'New Phone Number';
    // current_msisdn_label = 'Current Phone Number';
    oldMsisdn: string;
    newMsisdn: string;
    description: string;
    msisdnupdateviewlabels = MSISDNUPDATEVIEWLABELS;
    customerService: CustomerService;
    smsurlService: SmsURLService;
    requiredErrorMsg: string = "";

    isSameMsisdnError: boolean = false;
    sameMsisdnErrorMsg = "";

    constructor(private ds: DialogService, private translatePipe: TranslatePipe) {
        super(ds);

        this.requiredErrorMsg = this.translatePipe.transform("REQUIRED_FIELD", 'CLIENT_SIDE_VALIDATION_ERROR');

        this.isSameMsisdnError = false;
        this.sameMsisdnErrorMsg = "";
    }


    setCustomValidity(event) {

        if (event.target.value === '') {
            event.target.setCustomValidity(this.translatePipe.transform("REQUIRED_FIELD", 'CLIENT_SIDE_VALIDATION_ERROR'));
        }  
        else {
            event.target.setCustomValidity('');
        }

        return true;
    }

    setCustomValidityBlank(event) {
        event.target.setCustomValidity('');
    }

    mouseHover(event) {

        event.target.setAttribute("title", "");

        // if (event.target.value == "") {
        //     event.target.setAttribute("title", this.translatePipe.transform("REQUIRED_FIELD", 'CLIENT_SIDE_VALIDATION_ERROR'))
        // }
        // else {
        //     event.target.setAttribute("title", "")
        // }
    }


    keyDownEvent(e) {        

        if (e.which === 32)
            e.preventDefault();

        this.isSameMsisdnError = false;
        this.sameMsisdnErrorMsg = "";
    }

    apply(formData: any) {  

        if (!(this.newMsisdn) || (this.newMsisdn === null) || (this.newMsisdn.trim() == "") || (this.newMsisdn === undefined)) {

            formData.form.controls['newMail'].markAsDirty();
            formData.form.controls['newMail'].markAsTouched();
            formData.form.controls['newMail'].setErrors({ 'required': true });
            return;
        }      

        if(this.newMsisdn.trim() === this.oldMsisdn.trim()){  

            this.isSameMsisdnError = true;
            this.sameMsisdnErrorMsg = this.translatePipe.transform("SAME_PHONE_EXCEPTION", 'SHAREDCONSTANTS');

            // this.close();  
            // this.ds.addDialog(NotificationDialogComponent, {
            //     success: false,
            //     message: this.translatePipe.transform("SAME_PHONE_EXCEPTION",'SHAREDCONSTANTS')
            // });            
            return;
        }
        // else if (!(/^[0-9]+$/).test(this.newMsisdn.trim())) {
        //     this.close();
        //     this.ds.addDialog(NotificationDialogComponent, {
        //         success: false,
        //         message: this.translatePipe.transform("INVALID_MSISDN",'API_ERROR')
        //     });
        //     return;
        // }

        this.customerService.updateMSISDN(this.newMsisdn, this.subValue, this.opcoValue, this.ds,this.updateMSISDNStatus.bind(this));
    }
    updateMSISDNStatus(status,otherErrorStatus){
        status===false?this.close():"";
        if(status===true && otherErrorStatus===false){
            this.isSameMsisdnError = true;
            this.sameMsisdnErrorMsg = this.translatePipe.transform("INVALID_MSISDN", 'API_ERROR');
        }
    }
    sendOTPRequest(){
        this.smsurlService.sendOTP(this.newMsisdn, this.subValue, this.opcoValue, this.ds);
    }
}


// WEBPACK FOOTER //
// ./src/app/details/msisdnupdate/msisdn.update.dialog.component.ts